import React, { useState } from "react";
import { Link } from "react-router-dom";
import userAPI from "../../api/UserApi";
import { showError, showSuccess } from "../../utils/toastUtils";
import { setAccessToken } from "../../api/axiosInstance";
import useAlphabeticInput from "../../hooks/useAlphabeticInput";

function LoginCanvas() {
  useAlphabeticInput();

  const INITIAL_FORM_DATA = {
    email: "",
    password: "",
  };

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [errors, setErrors] = useState({});

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValidEmail = emailRegex.test(formData.email);
  const isValidPassword = formData.password.length >= 6;

  const validate = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = "Please Enter Email Address";
    } else if (!isValidEmail) {
      newErrors.email = "Please enter a valid email";
    }

    if (!formData.password) {
      newErrors.password = "Enter Password";
    } else if (!isValidPassword) {
      newErrors.password = "Password must be at least 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    try {
      const res = await userAPI.login(formData);

      if (res.code === 200) {
        showSuccess(res.message);
        setAccessToken(res.data.accessToken);

        const user = {
          email: res.data.email,
          username: res.data.username,
        };

        localStorage.setItem("token", JSON.stringify(user));
        localStorage.setItem("accessToken", res.data.accessToken);

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <>
      <div className="canvas-wrapper">
        <div className="canvas-header popup-header">
          <span className="title">Log in</span>
          <button
            className="icon-close icon-close-popup"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <div className="canvas-body popup-inner">
          <form method="post" className="form-login" onSubmit={handleSubmit}>
            <fieldset className="tf-field style-2 style-3">
              <input
                className="tf-field-input tf-input"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              <label className="tf-field-label" htmlFor="email">
                Email Address <span className="text-danger">*</span>
              </label>
              {errors && errors.email && (
                <span className="text-danger">{errors.email}</span>
              )}
            </fieldset>

            <fieldset className="tf-field style-2 style-3">
              <input
                className="tf-field-input tf-input"
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
              />
              <label className="tf-field-label" htmlFor="password">
                Password <span className="text-danger">*</span>
              </label>
              {errors && errors.password && (
                <span className="text-danger">{errors.password}</span>
              )}
            </fieldset>

            <div className="bot">
              <Link to="/forgot-password" className="text text-sm text-main-2">
                Forgot your password?
              </Link>
              <div className="button-wrap">
                <button
                  className="subscribe-button tf-btn animate-btn d-inline-flex bg-dark-2 w-100 submitbtn"
                  type="submit"
                >
                  Sign in
                </button>
              </div>
            </div>

            <p>
              Are You a New User? Click Here to{" "}
              <span
                data-bs-target="#registerOffCanvas"
                data-bs-toggle="offcanvas"
                className="text-primary"
              >
                Register
              </span>{" "}
              and Create Your Account to Get Started
            </p>

            {errors.general && (
              <span className="text-danger">{errors.general}</span>
            )}
          </form>

          <div className="other-login">
            <p className="text-sm text-center text-main-2 mb-2">
              Or sign in with:
            </p>
            <a
              href="#"
              className="subscribe-button tf-btn animate-btn d-inline-flex bg-dark-2 w-100"
            >
              <svg
                className="icon"
                width={32}
                height={32}
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_235_18876)">
                  <path
                    d="M30.7919 13.218L17.7394 13.2174C17.163 13.2174 16.6958 13.6845 16.6958 14.2609V18.4306C16.6958 19.0068 17.163 19.4741 17.7393 19.4741H25.0897C24.2848 21.5629 22.7825 23.3122 20.8659 24.4237L24.0001 29.8493C29.0277 26.9416 32.0001 21.8398 32.0001 16.1287C32.0001 15.3155 31.9402 14.7342 31.8203 14.0796C31.7292 13.5823 31.2974 13.218 30.7919 13.218Z"
                    fill="#167EE6"
                  />
                  <path
                    d="M16.0002 25.7392C12.4031 25.7392 9.26282 23.7738 7.57625 20.8655L2.15088 23.9926C4.91182 28.7777 10.0839 32 16.0002 32C18.9025 32 21.6411 31.2186 24.0002 29.8568V29.8494L20.866 24.4237C19.4324 25.2552 17.7734 25.7392 16.0002 25.7392Z"
                    fill="#12B347"
                  />
                  <path
                    d="M24 29.8568V29.8493L20.8658 24.4237C19.4322 25.2551 17.7733 25.7391 16 25.7391V32C18.9023 32 21.641 31.2186 24 29.8568Z"
                    fill="#0F993E"
                  />
                  <path
                    d="M6.26088 16C6.26088 14.2269 6.74475 12.5681 7.57606 11.1346L2.15069 8.00745C0.781375 10.3591 0 13.0903 0 16C0 18.9098 0.781375 21.6409 2.15069 23.9926L7.57606 20.8654C6.74475 19.4319 6.26088 17.7731 6.26088 16Z"
                    fill="#FFD500"
                  />
                  <path
                    d="M16.0002 6.26088C18.3459 6.26088 20.5005 7.09437 22.1834 8.48081C22.5986 8.82281 23.2021 8.79813 23.5824 8.41781L26.5368 5.46344C26.9683 5.03194 26.9375 4.32562 26.4766 3.92575C23.6569 1.47956 19.9881 0 16.0002 0C10.0839 0 4.91182 3.22231 2.15088 8.00744L7.57625 11.1346C9.26282 8.22625 12.4031 6.26088 16.0002 6.26088Z"
                    fill="#FF4B26"
                  />
                  <path
                    d="M22.1833 8.48081C22.5984 8.82281 23.2019 8.79813 23.5822 8.41781L26.5366 5.46344C26.968 5.03194 26.9373 4.32562 26.4764 3.92575C23.6567 1.4795 19.9879 0 16 0V6.26088C18.3456 6.26088 20.5003 7.09437 22.1833 8.48081Z"
                    fill="#D93F21"
                  />
                </g>
                <defs>
                  <clipPath>
                    <rect width={32} height={32} fill="white" />
                  </clipPath>
                </defs>
              </svg>
              GOOGLE
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoginCanvas;
